module.exports = __webpack_public_path__ + "static/media/yes.d29f1779.svg";